import { useQuery } from 'react-query';

import { DocChronology } from '../../../../backend/src/matter/subset/chronology/doc-chronology/doc-chronology.entity';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetDocChronology = ({
  matterId,
  subsetId,
  docChronologyId,
}: {
  matterId: string;
  subsetId: string;
  docChronologyId: string;
}) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DocChronology>(
    [QueryEntity.DocChronology, { docChronologyId }],
    () => {
      return fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology/${docChronologyId}`,
        fetchConfigGET,
      ).then((res) => {
        return res.json();
      });
    },
    { enabled: !!matterId && !!subsetId && !!docChronologyId },
  );
};
